import React from 'react';
import { classNames } from '../../utils';

interface IProps {
  links: {
    title: string;
    start: number;
    id: string;
  }[];
  text: {
    title: string;
    copy: string;
  };
  className?: string;
}

const OnboardingVideos = ({ links, text, className }: IProps) => {
  const vid = links[0];
  let videoUrl = `https://www.youtube-nocookie.com/embed/${vid.id}`;
  if (vid.start) {
    videoUrl += `?start=${vid.start}`;
  }

  return (
    <div className={classNames(className, 'OnboardingPanel_videosContainer')}>
      <div className="OnboardingPanel_title">{text.title}</div>
      <p className="OnboardingPanel_videosContainer copy">{text.copy}</p>
      <div className="OnboardingPanel_videosRow">
        <iframe
          width="100%"
          height="100%"
          src={videoUrl}
          title={vid.title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default OnboardingVideos;
